import React, { Fragment } from "react";
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import styled from "styled-components";
import PrimaryButton from "components/Global/Buttons/PrimaryButton";

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
  `;
const StyledCancelButton = styled(PrimaryButton)`
  &&& {
    margin-right:12px;
  }
`;

export const FavoriteModal = ({ isFavorite, isOpen, onClose, onSave }) => {
  const favoriteHeaderText = "Mark as favorite";
  const favoriteBodyText = "Marking this refinance scenario as your favorite will clear all other refinance scenarios, are you sure you want to do this?";

  const defavoriteHeaderText = "Unmark as favorite";
  const defavoriteBodyText = "Unmarking this refinance scenario as your favorite will reinstate all other refinance scenarios, are you sure you want to do this?";

  const close = () => {
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={close}
      style={{
        height: "400px"
      }}
      maxWidth="md"
    >
      <Grid
        container
        alignItems="center"
        justify="space-between"
      >
        <DialogTitle>{isFavorite ? defavoriteHeaderText : favoriteHeaderText}</DialogTitle>
      </Grid>
      <DialogContent>
        {isFavorite ? defavoriteBodyText : favoriteBodyText}
      </DialogContent>
      <StyledDialogActions>
        <>
          <StyledCancelButton onClick={close}>Cancel</StyledCancelButton>
          <StyledCancelButton
            onClick={() => {
              onSave();
            }}
          >
            Save
          </StyledCancelButton>
        </>
      </StyledDialogActions>
    </Dialog>
  );
};
